import $ from 'jquery';
window.jQuery = $;
window.$ = $;

$(document).ready(function() {
    console.log("page ready");

    $("#pulldown-hover").mouseover(function() {
        showPulldown();
    });
    $("#pulldown-hover").mouseout(function() {
        hidePulldown();
    });
    $("#pulldown").mouseover(function() {
        showPulldown();
    });
     $("#pulldown").mouseout(function() {
        hidePulldown();
    });
});

function showPulldown() {
    $("#pulldown").show();
    $("#up-arrow").show();
    $("#down-arrow").hide();
}
function hidePulldown() {
    $("#pulldown").hide();
    $("#down-arrow").show();
    $("#up-arrow").hide();
}

window.showPulldown = showPulldown;
window.hidePulldown = hidePulldown;
